import { Trans } from '@lingui/macro'
import Card /* , { DarkGreyCard } */ from 'components/Card'
import { /* AutoRow, */ RowBetween } from 'components/Row'
import { useEffect, useRef } from 'react'
import { ArrowDown, /* Info, */ X } from 'react-feather'
import ReactGA from 'react-ga4'
import styled from 'styled-components/macro'
import { /* ExternalLink, */ ThemedText } from 'theme'
import { isMobile } from 'utils/userAgent'

import { useModalOpen, useToggleGamesInfo } from '../../state/application/hooks'
import { ApplicationModal } from '../../state/application/reducer'
import { AutoColumn } from '../Column'
import Modal from '../Modal'

const Wrapper = styled.div`
  max-height: 70vh;
  overflow: auto;
  padding: 0 1rem;
  margin-bottom: 1rem;
`

const StyledExternalCard = styled(Card)`
  background-color: ${({ theme }) => theme.primary5};
  padding: 0.5rem;
  width: 100%;

  :hover,
  :focus,
  :active {
    background-color: ${({ theme }) => theme.primary4};
  }
`

const HoverText = styled.div`
  text-decoration: none;
  color: ${({ theme }) => theme.text1};
  display: flex;
  align-items: center;

  :hover {
    cursor: pointer;
  }
`

const StyledLinkOut = styled(ArrowDown)`
  transform: rotate(230deg);
`

export function GamesInfoModal() {
  const node = useRef<HTMLDivElement>()
  const open = useModalOpen(ApplicationModal.GAMES_INFO)
  const toggle = useToggleGamesInfo()

  useEffect(() => {
    if (!open) return

    ReactGA.event({
      category: 'Modal',
      action: 'Show Legal',
    })
  }, [open])

  return (
    <Modal isOpen={open} onDismiss={() => toggle()}>
      <AutoColumn gap="12px" ref={node as any}>
        <RowBetween padding="1rem 1rem 0.5rem 1rem">
          <ThemedText.MediumHeader>
            <Trans>Games Info</Trans>
          </ThemedText.MediumHeader>
          <HoverText onClick={() => toggle()}>
            <X size={24} />
          </HoverText>
        </RowBetween>
        <GamesInfo />
      </AutoColumn>
    </Modal>
  )
}

export function GamesInfo() {
  return (
    <Wrapper
      draggable="true"
      onTouchMove={(e) => {
        // prevent modal gesture handler from dismissing modal when content is scrolling
        if (isMobile) {
          e.stopPropagation()
        }
      }}
    >
      <AutoColumn gap="12px">
        <AutoColumn gap="8px" style={{ width: '100%' }}>
          <ThemedText.Main fontSize={14}>
            <Trans>
              The results may be delayed because we are in a decentralized system and the results depend on the network
              and the chainlink oracle
            </Trans>
            .
          </ThemedText.Main>
          <ThemedText.SubHeader fontSize={16}>
            <Trans>Help</Trans>
          </ThemedText.SubHeader>
          {/* <StyledExternalCard>
            <ExternalLink href={'https://uniswap.org/disclaimer/'}>
              <RowBetween>
                <AutoRow gap="4px">
                  <Info size={20} />
                  <ThemedText.Main fontSize={14} color={'primaryText1'}>
                    <Trans>Protocol Disclaimer</Trans>
                  </ThemedText.Main>
                </AutoRow>
                <StyledLinkOut size={20} />
              </RowBetween>
            </ExternalLink>
          </StyledExternalCard> */}
          <ThemedText.Main fontSize={14}>
            <Trans>Check that the transaction (tx) has been confirmed in your wallet</Trans>.
          </ThemedText.Main>
          <ThemedText.Main fontSize={14}>
            <Trans>
              If the result has not appeared, wait patiently until it appears in the game or in the betting history
            </Trans>
            .
          </ThemedText.Main>
          <ThemedText.Main fontSize={14}>
            <Trans>
              We are in the blockchain if your result has not been shown, rest assured that it will be stored in the
              contract
            </Trans>
            .
          </ThemedText.Main>
          {/* <StyledExternalCard>
            <ExternalLink href={'https://polygonscan.com/'}>
              <RowBetween>
                <AutoRow gap="6px">
                  <Info size={20} />
                  <ThemedText.Main fontSize={14} color={'primaryText1'}>
                    <Trans>View Contracts in PolygonScan</Trans>
                  </ThemedText.Main>
                </AutoRow>
                <StyledLinkOut size={20} />
              </RowBetween>
            </ExternalLink>
          </StyledExternalCard> */}
        </AutoColumn>
        {/*  <AutoColumn gap="12px">
          {EXTERNAL_APIS.map(({ name, description }, i) => (
            <DarkGreyCard key={i}>
              <AutoColumn gap="8px">
                <AutoRow gap="4px">
                  <Info size={18} />
                  <ThemedText.Main fontSize={14} color={'text1'}>
                    {name}
                  </ThemedText.Main>
                </AutoRow>
                <ThemedText.Main fontSize={14}>{description}</ThemedText.Main>
              </AutoColumn>
            </DarkGreyCard>
          ))}
          <ThemedText.Body fontSize={12}>
            <Row justify="center" marginBottom="1rem">
              <ExternalLink href="https://help.uniswap.org/en/articles/5675203-terms-of-service-faq">
                <Trans>Learn more</Trans>
              </ExternalLink>
            </Row>
          </ThemedText.Body>
        </AutoColumn> */}
      </AutoColumn>
    </Wrapper>
  )
}
